// PLP content spot: relocate the merchant-configured tile into the Boost SD product grid
// as the first card, and keep it there across Boost re-renders (filter / sort / paginate).
(() => {
  const GRID = '.boost-sd__product-list';
  const source = document.querySelector('[data-plp-content-spot]');
  if (!source) return;
  const tile = source.querySelector('.plp-content-spot');
  if (!tile) return;

  // The tile starts inside a display:none source node, so a lazy image never becomes viewport-
  // eligible and fails to load once we relocate the tile into the grid. Force it to load eagerly
  // (it's the first, above-the-fold card) so the merchant's uploaded image always shows (feedback).
  const spotImg = tile.querySelector('.plp-content-spot__img');
  if (spotImg) {
    spotImg.loading = 'eager';
    if (!spotImg.complete) { const s = spotImg.getAttribute('src'); if (s) spotImg.src = s; }
  }

  let observer = null;
  let hiddenCard = null;

  // The spot occupies one grid cell, so a full page of products would otherwise wrap one
  // product onto a new row with an empty gap beside it. Rather than fight Boost's server-side
  // pagination (risky), hide the single trailing product so the rows stay complete. It's a
  // display-only hide (the product still loads and reappears as more products page in).
  const balance = (grid) => {
    if (hiddenCard) { hiddenCard.style.display = ''; hiddenCard = null; }
    const items = Array.prototype.filter.call(
      grid.children,
      (c) => c !== tile && c.classList && c.classList.contains('boost-sd__product-item') && c.style.display !== 'none'
    );
    const last = items[items.length - 1];
    if (last) { last.style.display = 'none'; hiddenCard = last; }
  };

  const inject = () => {
    const grid = document.querySelector(GRID);
    if (!grid) return false;
    if (grid.firstElementChild !== tile) grid.insertBefore(tile, grid.firstElementChild);
    balance(grid);
    return true;
  };

  const watch = () => {
    const grid = document.querySelector(GRID);
    if (!grid) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(() => {
      // Boost replaces/append the grid's children on re-render; re-insert + re-balance.
      if (tile.parentElement !== grid || grid.firstElementChild !== tile || (hiddenCard && !hiddenCard.parentElement)) inject();
    });
    observer.observe(grid, { childList: true });
  };

  const start = () => {
    if (inject()) {
      watch();
      return true;
    }
    return false;
  };

  // The grid is app-rendered and may arrive after us — poll briefly until it exists.
  if (!start()) {
    let tries = 0;
    const timer = setInterval(() => {
      if (start() || ++tries > 40) clearInterval(timer);
    }, 250);
  }
})();
